<template>
  <form v-bind="$attrs" ref="form" @submit.prevent="()=>{}">
    <div class="main-form">
      <dd-form-indicator
          v-if="multipleSteps"
          @go-to-step="goToStep"
          :steps="steps"
          :activeStepIndex="activeStepIndex"
      ></dd-form-indicator>

      <slot></slot>

      <div class="action-buttons" v-if="steps && !hideButtons">
        <dd-button data-dusk="previous-step" @click="prevStep" v-if="activeStepIndex !== 0 && multipleSteps" type="info">terug</dd-button>
        <dd-button data-dusk="next-step" @click="nextStep" v-if="!lastStep && multipleSteps" type="primary" :disabled="currentStepInvalid">volgende</dd-button>
        <dd-button data-dusk="submit"  @click="submit" v-if="!multipleSteps || lastStep" type="success" :disabled="currentStepInvalid">
          <template #icon>
            <ContentSave class="icon-size-md"></ContentSave>
          </template>
          opslaan
        </dd-button>
      </div>
    </div>
  </form>
</template>

<script>
import ContentSave from 'vue-material-design-icons/ContentSave.vue';
export default {
  name: "MainForm.vue",
  emits: ['submit'],
  components: {
    ContentSave
  },
  mounted() {
    let formElement = this.$refs.form;
    this.steps = formElement.getElementsByClassName('form-step');
    this.updateSteps();
    if(this.validOnInit) {
      this.initializeValidSteps();
    }
    this.checkFormStepIsValid();
  },
  props: {
    validOnInit:  {
      type: Boolean,
      required: false,
      default: true,
    },
    hideButtons:  {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      activeStepIndex: 0,
      steps: [],
      validSteps: {},
    }
  },
  methods: {
    nextStep() {
      if (this.activeStepIndex + 1 >= this.steps.length) return;
      this.activeStepIndex++;
      this.goToStep(this.activeStepIndex);
    },
    prevStep() {
      if (this.activeStepIndex - 1 < 0) return;
      this.activeStepIndex--;
      this.goToStep(this.activeStepIndex);
    },
    updateSteps() {
      for (let step of this.steps) {
        step.classList.add('hidden');
      }
      this.steps[this.activeStepIndex].classList.remove('hidden');
    },
    submit() {
      this.$emit('submit', this.$refs.form);
    },
    initializeValidSteps() {
      // Asume all are valid on load
      for (let i = 0; i < this.steps.length; i++) {
        let clone = Object.assign({}, this.validSteps);
        clone[i] = true;
        this.validSteps = clone;
      }
    },
    goToStep(stepIndex) {
      // If current step isn't complete yet return.
      if (stepIndex > this.activeStepIndex && this.currentStepInvalid) return;
      this.activeStepIndex = stepIndex;
      this.updateSteps();
    },
    checkFormStepIsValid() {
      if (!this.steps || this.steps.length === 0) return;
      let observer = new MutationObserver(() => {
        if (this.steps[this.activeStepIndex].hasAttribute('invalid')) {
          let clone =  Object.assign({}, this.validSteps);
          delete clone[this.activeStepIndex];
          this.validSteps = clone;
        }
        else {
          this.validSteps = {...this.validSteps, [this.activeStepIndex]: true}
        }
      });
      observer.observe(this.$refs.form, {
        attributes: true,
        attributeFilter: ['invalid'],
        subtree: true
      });
    },
  },
  computed: {
    currentStepInvalid() {
      return this.activeStepIndex in this.validSteps ? false : true;
    },
    multipleSteps() {
      return this.steps.length > 1;
    },
    lastStep() {
      if (this.activeStepIndex + 1 === this.steps.length) return true;
    },
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";

.hidden {
  display: none;
}
.main-form {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  row-gap: $spacing-lg;

  .action-buttons {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    gap: $spacing-sm;
  }
}
</style>
